export enum PATHS_API {
  Auth_login = '/auth/login',
  Auth_me = '/auth/me',
  Auth_register = '/auth/register',
  Cards_card = '/cards/card',
  Cards_pack = '/cards/pack',
  Cards_grade = '/cards/grade',
}
